import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/close.svg'
import _imports_1 from '../../assets/img/shop/product-thumb-1.webp'
import _imports_2 from '../../assets/img/shop/product-thumb-2.webp'


const _hoisted_1 = { class: "cart-wrap ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "cart-table" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "product-item" }
const _hoisted_6 = { class: "product-item" }
const _hoisted_7 = { class: "row pt-100" }
const _hoisted_8 = { class: "col-lg-5 offset-lg-7 col-md-8 offset-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text_secondary fs-20 f-secondary"
              }, " Product "),
              _createElementVNode("th", {
                scope: "col",
                class: "text_secondary fs-20 f-secondary"
              }, " Price "),
              _createElementVNode("th", {
                scope: "col",
                class: "text_secondary fs-20 f-secondary"
              }, " Quantity "),
              _createElementVNode("th", {
                scope: "col",
                class: "text_secondary fs-20 f-secondary"
              }, " Subtotal ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("button", {
                    class: "cart-action",
                    type: "button"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Image"
                    })
                  ], -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "product-img d-flex flex-column align-items-center justify-content-center" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "Image"
                    })
                  ], -1)),
                  _createVNode(_component_router_link, {
                    class: "cart-item f-secondary text_secondary",
                    to: "/product-details"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("span", null, "Cat Fish Food", -1)
                    ])),
                    _: 1
                  })
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text_secondary" }, "$59.00", -1)),
              _createElementVNode("td", null, [
                _createVNode(_component_QuantityCounter)
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("td", null, "$59.00", -1))
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("button", {
                    class: "cart-action",
                    type: "button"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Image"
                    })
                  ], -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "product-img d-flex flex-column align-items-center justify-content-center" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Image"
                    })
                  ], -1)),
                  _createVNode(_component_router_link, {
                    class: "cart-item f-secondary text_secondary",
                    to: "/product-details"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("span", null, "Can Food", -1)
                    ])),
                    _: 1
                  })
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "text_secondary" }, "$56.00", -1)),
              _createElementVNode("td", null, [
                _createVNode(_component_QuantityCounter)
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("td", null, "$56.00", -1))
            ])
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"row pb-45\"><div class=\"col-xl-5 col-lg-7 col-md-7 col-sm-8 mb-25\"><div class=\"coupon-code\"><input type=\"text\" placeholder=\"Coupon Code\"><button type=\"button\" class=\"btn style-one\">Apply Coupon</button></div></div><div class=\"col-xl-7 col-lg-5 col-md-5 col-sm-4 text-sm-end mb-25\"><button class=\"btn style-four update-cart\" type=\"button\"> Update Cart </button></div></div>", 1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"cart-total style-two\"><h2 class=\"section-title\">Cart Total</h2><div class=\"cart-total-wrap\"><div class=\"cart-total-item\"><h6>Subtotal</h6><h6>$170.97</h6></div><div class=\"cart-total-item\"><h6>Shipping</h6><div class=\"select-payment-method mt-20 text-end\"><div><input type=\"radio\" id=\"test1\" name=\"radio-group\"><label for=\"test1\">Free Shipping</label></div><div><input type=\"radio\" id=\"test3\" name=\"radio-group\"><label for=\"test3\">Flat Rate</label></div><div><input type=\"radio\" id=\"test2\" name=\"radio-group\"><label for=\"test2\">Local Pickup</label></div></div></div><div class=\"cart-total-item\"><h6>Total</h6><h6>$170.97</h6></div></div></div>", 1)),
          _createVNode(_component_router_link, {
            class: "btn style-one update-cart",
            to: "/checkout"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Proceed To Checkout ")
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}